import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { ControlValueAccessorModel, getProvider } from '../../../Forms/models/control-value-accessor.model';
import { ButtonTypesEnum } from '../../enums/button-types.enum';
import { MonitorConfigService } from '../../../MonitorShared/services/monitor-config.service';
import { CopilotSwitchBannerVariantEnum } from './copilot-switch-banner-variant.enum';

@Component({
    selector: 'agpr-copilot-switch-banner',
    templateUrl: './copilot-switch-banner.component.html',
    styleUrls: ['./copilot-switch-banner.component.scss'],
    providers: [getProvider(CopilotSwitchBannerComponent)],
    standalone: false
})
export class CopilotSwitchBannerComponent extends ControlValueAccessorModel<boolean> implements OnInit, OnDestroy {
    @Input() id: string = 'copilotSwitchBanner';
    @Input() description: string = null;
    @Input() variant: CopilotSwitchBannerVariantEnum = CopilotSwitchBannerVariantEnum.default;
    @Input() skipCoverageInsights: boolean = false;
    @Input() isCollapsed: boolean = false;
    @Input() title: string = 'Briefing.onlineBriefing.template.openAiHeading';

    readonly buttonTypes = ButtonTypesEnum;
    readonly variantEnum = CopilotSwitchBannerVariantEnum;

    subscriptions: Subscription[] = [];
    hasCoverageInsightsEnabled: boolean = false;


    constructor(
        private monitorConfigService: MonitorConfigService
    ) {
        super();
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.monitorConfigService.getHasCoverageInsightsEnabled().subscribe(x => {
                this.hasCoverageInsightsEnabled = x;
            })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    writeValue(value: boolean): void {
        this.value = value;
    }

    learnMore(): void {
        window.open('https://www.agilitypr.com/contact/');
    }

}
